import { nameSpace } from './nameSpace';
import { createSliceWithName as dataGridSlice } from 'modules/dataGridTable/reducer';
import { createSelectors } from 'modules/dataGridTable/selectors';

export const moduleName = 'dataGridTable';
export const selectstate = state => state[nameSpace][moduleName];

const initialState = {
  list: [],
  details: {},
  selectedRowID: null,
  forceRefresh: false,
  totalEntries: 0,
  dummyRowData: {},
};

const dataGrid = dataGridSlice(`${nameSpace}/${moduleName}`, initialState);

export const { reducer } = dataGrid;
export const { actions } = dataGrid;
export const selectors = createSelectors(selectstate);
